/* unplugin-vue-components disabled */import script from "./Invitation.vue?vue&type=script&lang=ts&setup=true"
export * from "./Invitation.vue?vue&type=script&lang=ts&setup=true"

import "./Invitation.vue?vue&type=style&index=0&id=19cc7ee2&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19cc7ee2"]])

export default __exports__